import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "image__lazy" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "placeholder-glow" }, [
    /*#__PURE__*/ _createElementVNode("span", {
        class: "placeholder bg-secondary image__placeholder image-item",
        style: { "border-radius": "5px" }
    })
], -1);
const _hoisted_3 = ["data-url", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_lazy_load = _resolveDirective("lazy-load");
    return _withDirectives((_openBlock(), _createElementBlock("figure", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("img", {
            "data-url": _ctx.src,
            alt: _ctx.alt,
            class: "image-item"
        }, null, 8, _hoisted_3)
    ])), [
        [_directive_lazy_load]
    ]);
}
